var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VBtn',{staticClass:"button-wrapper",attrs:{"icon":""}},[_c('div',{staticClass:"radio",class:{ selected: _vm.isActive }})])
}
var staticRenderFns = []

export { render, staticRenderFns }